import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import { SCHEDULED_MESSAGES_BASE_QUERY_KEY } from './scheduledMessagesQuery';

type ReactivateScheduledMessageMutationArgs = {
  scheduledMessageUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    {},
    BaseErrorResponse,
    ReactivateScheduledMessageMutationArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const reactivateScheduledMessage = ({
  scheduledMessageUid,
}: ReactivateScheduledMessageMutationArgs) => {
  return API.post<{}, BaseErrorResponse>(
    `/api/internal/triggers/scheduled-messages/reactivate/${scheduledMessageUid}`,
  );
};

const useReactivateScheduledMessageMutation = ({
  onSuccess,
  ...options
}: ReactQueryMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: reactivateScheduledMessage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([SCHEDULED_MESSAGES_BASE_QUERY_KEY]);
      return onSuccess?.(...args);
    },
    ...options,
  });
};

export default useReactivateScheduledMessageMutation;
